import { analyticsSlice } from './slice';


export default {
  ...analyticsSlice.actions,
};
